export const EmMarket = 'emmarket';

export const OPENMARKET = 'openmarket';

export const HIDE_TOP_COMPANIES = 'hideTopCompanies';
export const HIDE_POSTS_FILTERS = 'hidePostsFilters';

export const CORPORATE_ACTIVE_CALENDAR = 'corporateActiveCalendar';

export const BOND_SCREENER_CUSTOM_VIEWS = 'bondScreenerCustomViews';
export const BOND_SCREENER_CUSTOM_VIEWS_DESCRIPTION = 'bondScreenerCustomViewsDescription';
export const BOND_SCREENER_CUSTOM_VIEWS_SELECT = 'bondScreenerCustomViewsSelect';
export const BOND_SCREENER_CUSTOM_VIEWS_RENAME = 'bondScreenerCustomViewsRename';
export const BOND_SCREENER_CUSTOM_VIEWS_PRESETS = 'bondScreenerCustomViewsPresets';
export const BOND_SCREENER_CUSTOM_VIEWS_SEARCH = 'bondScreenerCustomViewsSearch';

export const BOND_SCREENER_EXPORT_DROPDOWN = 'bondScreenerExportDropdown';

export const BOND_SCREENER_SELECT_VIEW = 'bondScreenerSelectView';

export const ASK_AI = 'askAi';

export const featureToggle: Record<string, { cookieName: string }> = {
  [EmMarket]: {
    cookieName: EmMarket,
  },
  [OPENMARKET]: {
    cookieName: OPENMARKET,
  },
  [HIDE_TOP_COMPANIES]: {
    cookieName: HIDE_TOP_COMPANIES,
  },
  [HIDE_POSTS_FILTERS]: {
    cookieName: HIDE_POSTS_FILTERS,
  },
  [CORPORATE_ACTIVE_CALENDAR]: {
    cookieName: CORPORATE_ACTIVE_CALENDAR,
  },
  [BOND_SCREENER_CUSTOM_VIEWS]: {
    cookieName: BOND_SCREENER_CUSTOM_VIEWS,
  },
  [BOND_SCREENER_CUSTOM_VIEWS_DESCRIPTION]: {
    cookieName: BOND_SCREENER_CUSTOM_VIEWS_DESCRIPTION,
  },
  [BOND_SCREENER_CUSTOM_VIEWS_SELECT]: {
    cookieName: BOND_SCREENER_CUSTOM_VIEWS_SELECT,
  },
  [BOND_SCREENER_CUSTOM_VIEWS_RENAME]: {
    cookieName: BOND_SCREENER_CUSTOM_VIEWS_RENAME,
  },
  [BOND_SCREENER_CUSTOM_VIEWS_PRESETS]: {
    cookieName: BOND_SCREENER_CUSTOM_VIEWS_PRESETS,
  },
  [BOND_SCREENER_CUSTOM_VIEWS_SEARCH]: {
    cookieName: BOND_SCREENER_CUSTOM_VIEWS_SEARCH,
  },
  [BOND_SCREENER_EXPORT_DROPDOWN]: {
    cookieName: BOND_SCREENER_EXPORT_DROPDOWN,
  },
  [BOND_SCREENER_SELECT_VIEW]: {
    cookieName: BOND_SCREENER_SELECT_VIEW,
  },
  [ASK_AI]: {
    cookieName: ASK_AI,
  },
} as const;
